import type { MembershipPaymentSummary } from "apis/v3/authApi";

export const CANCEL_MEMBERSHIP_RECENT_PAYMENT_HOURS = 72;

const MS_PER_HOUR = 60 * 60 * 1000;

export function hasCompletedPaymentWithinHours(
  payments: MembershipPaymentSummary[],
  withinHours: number
): boolean {
  const cutoffMs = Date.now() - withinHours * MS_PER_HOUR;

  return payments.some((payment) => {
    if (payment.paymentStatus !== "COMPLETED") {
      return false;
    }
    const authorizationDate = payment.authorizationDate?.trim();
    if (!authorizationDate) {
      return false;
    }
    const paidAtMs = Date.parse(authorizationDate);
    return Number.isFinite(paidAtMs) && paidAtMs >= cutoffMs;
  });
}
